// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./icons-svg.d.ts" />

import * as React from "react"
import "./icons.css"
import cn from "classnames"
import DatePickerSVG from "./svg/date-picker.svg"
import DownloadSVG from "./svg/download.svg"
import DownloadFullSVG from "./svg/download-full.svg"
import EditSVG from "./svg/edit.svg"
import ExclamationSVG from "./svg/exclamation.svg"
import ExclamationTriangleSVG from "./svg/exclamation-triangle.svg"
import RemoveSVG from "./svg/remove.svg"
import ReturnSVG from "./svg/return.svg"
import SaveSVG from "./svg/save.svg"
import ChevronUpSVG from "./svg/chevron-up.svg"
import ChevronDownSVG from "./svg/chevron-down.svg"
import ChevronLeftSVG from "./svg/chevron-left.svg"
import ChevronRightSVG from "./svg/chevron-right.svg"
import ChevronDoubleUpSVG from "./svg/chevron-double-up.svg"
import CloseSVG from "./svg/close.svg"
import VerticalDotsSVG from "./svg/dots-vertical.svg"
import TrashSVG from "./svg/trash.svg"
import UndoSVG from "./svg/undo.svg"
import RedoSVG from "./svg/redo.svg"
import ResetSVG from "./svg/reset.svg"
import ResetAltSVG from "./svg/reset-alt.svg"
import ExpandSVG from "./svg/expand.svg"
import CollapseSVG from "./svg/collapse.svg"
import BellSVG from "./svg/bell.svg"
import NoInternetSVG from "./svg/no-internet.svg"
import ArrowSwitchSVG from "./svg/arrow-switch.svg"
import CopySVG from "./svg/copy.svg"
import Center_SVG from "./svg/center.svg"
import ErrorExclamationSVG from "./svg/error-exclamation.svg"
import SimpleSmileySVG from "./svg/simple-smiley.svg"
import HamburgerSVG from "./svg/hamburger.svg"
import BasicLicenseSVG from "./svg/license-basic.svg"
import StandardLicenseSVG from "./svg/license-standard.svg"
import ChevronRightDarkSVG from "./svg/chevron-right-dark.svg"
import CreatorLicenseSVG from "./svg/license-creator.svg"
import DragLightSVG from "./svg/drag-light.svg"
import DragDarkSVG from "./svg/drag-dark.svg"
import QuestionMarkSVG from "./svg/question-mark.svg"
import StatusErrorSVG from "./svg/status-error.svg"
import StatusWarningSVG from "./svg/status-warning.svg"
import StatusMessageSVG from "./svg/status-message.svg"
import CheckmarkSVG from "./svg/checkmark.svg"
import MessageSVG from "./svg/message.svg"
import FolderSVG from "./svg/folder.svg"
import MapSVG from "./svg/map.svg"
import XSVG from "./svg/x-mark.svg"
import QuestionSymbolSVG from "./svg/question-symbol.svg"
import IconToolSVG from "./svg/icon-tool.svg"
import ActiveIconToolSVG from "./svg/icon-tool-active.svg"
import CircleSVG from "./svg/circle.svg"
import SquareSVG from "./svg/square.svg"
import TriangleSVG from "./svg/triangle.svg"
import StarShapeSVG from "./svg/star-shape.svg"
import DiamondSVG from "./svg/diamond.svg"
import CrossSVG from "./svg/cross.svg"
import CompassSVG from "./svg/compass.svg"
import AsteriskSVG from "./svg/asterisk.svg"
import BorderTickSVG from "./svg/border-ticks.svg"
import CapitalTSVG from "./svg/capital-t.svg"
import CapitalT2SVG from "./svg/capital-t2.svg"
import DocumentSVG from "./svg/document.svg"
import DraftSVG from "./svg/draft.svg"
import GridLineSVG from "./svg/grid-lines.svg"
import InsetSVG from "./svg/inset.svg"
import PngIconSVG from "./svg/png-icon.svg"
import QrCodeSVG from "./svg/qr-code.svg"
import RatioBarSVG from "./svg/ratio-bar.svg"
import ScaleBarSVG from "./svg/scale-bar.svg"
import ThreeDotsSettingsSVG from "./svg/vertical-3-dots.svg"
import ColoredCompassSVG from "./svg/colored-compass.svg"
import SampleQrCodeSVG from "./svg/sample-qr.svg"
import CursorSVG from "./svg/cursor.svg"
import KanbanSVG from "./svg/kanban.svg"
import ReversedKanbanSVG from "./svg/reversed-kanban.svg"
import OpenFolderSVG from "./svg/open-folder.svg"
import CrownSVG from "./svg/crown.svg"
import HomeSVG from "./svg/home.svg"
import NovaLogoSVG from "./svg/nova-logo-1.svg"
import NovaLogoInvertedSVG from "./svg/nova-logo-inverted.svg"
import NovaLogoStrippedSVG from "./svg/nova-logo-stripped.svg"
import NovaLogoV2SVG from "./svg/nova-logo-2.svg"
import NovaLogoTitleSVG from "./svg/nova-logo-with-title.svg"
import HotspotSVG from "./svg/hotspot.svg"
import HotspotHeatDotSVG from "./svg/hotspot-heat-dot.svg"
import FlightPathSVG from "./svg/flight-path.svg"
import PerimeterSVG from "./svg/basic-perimeter.svg"
import PerimeterThickSVG from "./svg/basic-perimeter-thick.svg"
import HorizontalKebabSVG from "./svg/horizontal-kebab.svg"
import PDFIconSVG from "./svg/pdf-icon.svg"
import SettingsCogSVG from "./svg/settings-cog.svg"
import DisabledDownloadSVG from "./svg/disabled-download.svg"
import DarkPDFIconSVG from "./svg/dark-pdf-icon.svg"
import MapPluginSVG from "./svg/map-plugin.svg"
import AppearanceSVG from "./svg/appearance.svg"
import KeyboardSVG from "./svg/keyboard.svg"
import CenterLightSVG from "./svg/center-light.svg"
import PluginTrashSVG from "./svg/plugin-trash.svg"
import ShortPanelSVG from "./svg/short-panel.svg"
import HiddenPanelSVG from "./svg/hidden-panel.svg"
import ExpandedPanelSVG from "./svg/expanded-panel.svg"
import PolygonThumbnailSVG from "./svg/Poly_Thumbnail.svg"
import HotspotPointSVG from "./svg/hotspot-point.svg"
import HotspotPolygonSVG from "./svg/hotspot-polygon.svg"
import HotspotOrthoSVG from "./svg/hotspot-ortho.svg"
import ColorSwatchSVG from "./svg/color-swatch.svg"
import HeatSwatchSVG from "./svg/heat-swatch.svg"
import HexSwatchSVG from "./svg/hex-swatch.svg"
import HotspotHeatSVG from "./svg/hotspot-heat.svg"
import HotspotHexSVG from "./svg/hotspot-hex.svg"
import GradientSVG from "./svg/gradient.svg"
import PerimeterDistanceSVG from "./svg/perimeter-distance.svg"
import ManualHotspotSVG from "./svg/manual-hotspot.svg"
import ManualHotspotLightSVG from "./svg/manual-hotspot-light.svg"
import HotspotFlightPathSVG from "./svg/hotspot-flight-path.svg"
import HotspotNumberSVG from "./svg/hotspot-number.svg"
import HotspotSensitivitySVG from "./svg/hotspot-sensitivity.svg"
import HotspotScanAreaSVG from "./svg/hotspot-scan-area.svg"
import TransparentSwatchSVG from "./svg/transparent-swatch.svg"
import FillSVG from "./svg/fill.svg"
import OutlineSVG from "./svg/outline.svg"
import InviteSVG from "./svg/invite.svg"
import PencilSVG from "./svg/pencil.svg"
import PlusSVG from "./svg/plus.svg"
import RulerSVG from "./svg/ruler.svg"
import RulerToolIconSVG from "./svg/ruler-tool-icon.svg"
import LengthSVG from "./svg/length.svg"
import LineToolSVG from "./svg/line-tool.svg"
import UploadSVG from "./svg/upload.svg"
import MinusSVG from "./svg/minus.svg"
import IconLayerSVG from "./svg/icon-layer.svg"
import VideoPluginSVG from "./svg/video-plugin.svg"
import LiveVideoPluginSVG from "./svg/live-stream-plugin.svg"
import ColorfinderPluginSVG from "./svg/colorfinder-plugin.svg"
import ImageColorfinderPluginSVG from "./svg/image-colorfinder-plugin.svg"
import PerimeterPluginSVG from "./svg/perimeter.svg"
import VisibilityEyeSVG from "./svg/visibility-eye.svg"
import VisibilityEyeOffSVG from "./svg/visibility-eye-off.svg"
import PerimeterPluginDarkSVG from "./svg/perimeter-plugin-dark.svg"
import ManualHotspotActionSVG from "./svg/manual-hotspot-action.svg"
import UploadActionSVG from "./svg/upload-action.svg"
import UploadImageColorfinderSVG from "./svg/upload-image-color-finder.svg"
import UploadVideoColorfinderSVG from "./svg/upload-video-color-finder.svg"
import AutomatedSVG from "./svg/automated.svg"
import ProcessingSVG from "./svg/processing.svg"
import LineToolSidePanelSVG from "./svg/line-tool-side-panel.svg"
import GroupSVG from "./svg/group.svg"
import GroupOpenSVG from "./svg/group-open.svg"
import CenterWhiteSVG from "./svg/center-white.svg"
import TextIconSVG from "./svg/text-icon.svg"
import FontBoldSVG from "./svg/font-bold.svg"
import FontSizeSVG from "./svg/font-size.svg"
import ColorTimelineSVG from "./svg/color-timeline.svg"
import ColorSpaceSVG from "./svg/color-space.svg"
import CrosshairSVG from "./svg/crosshair.svg"
import BoundingboxSVG from "./svg/box.svg"
import GearSVG from "./svg/gear.svg"
import OrientationSVG from "./svg/orientation.svg"
import MapPositionSVG from "./svg/map-position.svg"
import NotationSVG from "./svg/notation.svg"
import CoordinateSystemSVG from "./svg/coordinate-system.svg"
import TextSidePanelSVG from "./svg/text-side-panel.svg"
import MagnifyingGlassSVG from "./svg/magnifying-glass.svg"
import FilterSVG from "./svg/filter.svg"
import KeyboardCommandSVG from "./svg/keyboard-command.svg"
import KeyboardShiftSVG from "./svg/keyboard-shift.svg"
import KeyboardLeftClickSVG from "./svg/keyboard-left-click.svg"
import KeyboardRightClickSVG from "./svg/keyboard-right-click.svg"
import KeyboardBackspaceSVG from "./svg/keyboard-backspace.svg"
import PlaySVG from "./svg/play.svg"
import PlayCircleSVG from "./svg/play-circle.svg"
import PauseCircleSVG from "./svg/pause-circle.svg"
import PauseSVG from "./svg/pause.svg"
import NoFilterArrowSVG from "./svg/no-filter-arrow.svg"
import AscendingArrowSVG from "./svg/ascending-arrow.svg"
import DescendingArrowSVG from "./svg/descending-arrow.svg"
import PanoramaPluginSVG from "./svg/panorama-plugin.svg"
import PanoramaTopLeftSVG from "./svg/panorama-top-left.svg"
import PanoramaSplitSVG from "./svg/panorama-split.svg"
import PanoramaFullSVG from "./svg/panorama-full.svg"
import ShareSVG from "./svg/share.svg"
import PersonShareSVG from "./svg/person-share.svg"
import StarSVG from "./svg/star.svg"
import StarFillSVG from "./svg/star-fill.svg"
import UnfoldMoreSVG from "./svg/unfold-more.svg"
import RecentSVG from "./svg/recent.svg"
// import CampaignSVG from "./svg/campaign.svg"
import HelpSVG from "./svg/help.svg"
import ExitSVG from "./svg/exit.svg"
import OpenInNewSVG from "./svg/open-in-new.svg"
import MoveToSVG from "./svg/move-to.svg"
import CreateFolderSVG from "./svg/create-folder.svg"
import PeopleSVG from "./svg/people.svg"
import PersonAddSVG from "./svg/person-add.svg"
import ListSVG from "./svg/list.svg"
import GridSVG from "./svg/grid.svg"
import ArrowUpSVG from "./svg/arrow-up.svg"
import ArrowRightSVG from "./svg/arrow-right.svg"
import ArrowLeftSVG from "./svg/arrow-left.svg"
import ArrowDropdownSVG from "./svg/arrow-dropdown.svg"
import ArrowDropdownRightSVG from "./svg/arrow-dropdown-right.svg"
import LightbulbSVG from "./svg/lightbulb.svg"
import MailSVG from "./svg/mail.svg"
import MessageBubbleQuickSVG from "./svg/message-bubble-quick.svg"
import BugSVG from "./svg/bug.svg"
import ConfigurationSVG from "./svg/configuration.svg"
import PendingSVG from "./svg/pending.svg"
import ManageAccountsSVG from "./svg/manage-accounts.svg"
import LanguageSVG from "./svg/language.svg"
import ErrorSVG from "./svg/error.svg"
import WarningSVG from "./svg/warning.svg"
import InformationSVG from "./svg/information.svg"
import Pen4SVG from "./svg/pen-4.svg"
import ToolboxMapSVG from "./svg/toolbox-map.svg"
import OverlapSVG from "./svg/overlap.svg"
import NoAccountSVG from "./svg/no-account.svg"
import PersonRemoveSVG from "./svg/person-remove.svg"
import PersonEditSVG from "./svg/person-edit.svg"
import InvoiceSVG from "./svg/invoice.svg"
import ShoppingCartSVG from "./svg/shopping-cart.svg"
import KeySVG from "./svg/key.svg"
import UsageSVG from "./svg/usage.svg"
import LicenseSVG from "./svg/license.svg"
import AddOnSVG from "./svg/add-on.svg"
import PersonAdminSVG from "./svg/person-admin.svg"
import UpgradeSVG from "./svg/upgrade.svg"
import PersonUpgradeSVG from "./svg/person-upgrade.svg"
import CheckoutEssentialsSVG from "./svg/checkout-essentials.svg"
import CheckoutProSVG from "./svg/checkout-pro.svg"
import CheckoutColorfinderSVG from "./svg/checkout-colorfinder.svg"
import CheckoutHotspotsSVG from "./svg/checkout-hotspots.svg"
import CheckoutVideoSVG from "./svg/checkout-video.svg"
import HotspotAddOnSVG from "./svg/hotspot-addon.svg"
import ColorFinderAddOnSVG from "./svg/colorfinder-addon.svg"
import LiveVideoAddOnSVG from "./svg/live-video-addon.svg"
import LiveDroneSVG from "./svg/drone-live.svg"
import PlaceholderSVG from "./svg/placeholder.svg"
import InsertTextSVG from "./svg/insert-text.svg"
import PinDropSVG from "./svg/pin-drop.svg"
import PolylineSVG from "./svg/polyline.svg"
import WidgetsSVG from "./svg/widgets.svg"
import CompassNeedleLightSVG from "./svg/compass-needle-light.svg"
import CompassNeedleDarkSVG from "./svg/compass-needle-dark.svg"
import BackupSVG from "./svg/backup.svg"
import ZoomToSVG from "./svg/zoom-to.svg"
import BucketColorSVG from "./svg/bucket-color.svg"
import SquareSwatchSVG from "./svg/square-swatch.svg"
import CheckmarkShadowSVG from "./svg/checkmark-shadow.svg"
import LineNormalSVG from "./svg/line-normal.svg"
import LineDashedSVG from "./svg/line-dashed.svg"
import LineDottedSVG from "./svg/line-dotted.svg"
import LineSquaredSVG from "./svg/line-squared.svg"
import LineThicknessNormalSVG from "./svg/line-thickness-normal.svg"
import LineThicknessThickSVG from "./svg/line-thickness-thick.svg"
import LineThicknessNoneSVG from "./svg/line-thickness-none.svg"
import LineWeightThinSVG from "./svg/line-weight-thin.svg"
import LineWeightThickSVG from "./svg/line-weight-thick.svg"
import useLandscapeSVG from "./svg/use-landscape.svg"
import useAltitudeSVG from "./svg/use-altitude.svg"
import StacksSVG from "./svg/stacks.svg"
import HotspotPlaceableSVG from "./svg/hotspot-placeable.svg"
import RestartAltSVG from "./svg/restart-alt.svg"
import AddLocationSVG from "./svg/add-location.svg"
import PictureInPictureSVG from "./svg/picture-in-picture.svg"
import EmailListSVG from "./svg/email-list.svg"
import ContactEmergencySVG from "./svg/contact-emergency.svg"
import LoupeSVG from "./svg/loupe.svg"
import GradientWhiteHotSVG from "./svg/gradient-white-hot.svg"
import GradientBlackHotSVG from "./svg/gradient-black-hot.svg"
import GradientTintSVG from "./svg/gradient-tint.svg"
import GradientIronRedSVG from "./svg/gradient-iron-red.svg"
import GradientFulguriteSVG from "./svg/gradient-fullgurite.svg"
import GradientMedicalSVG from "./svg/gradient-medical.svg"
import GradientDefaultSVG from "./svg/gradient-default.svg"
import GradientDefaultSelectedSVG from "./svg/gradient-default-selected.svg"
import LocationCountrySVG from "./svg/location-country.svg"
import LocationStateSVG from "./svg/location-state.svg"
import LocationCitySVG from "./svg/location-city.svg"
import LocationAddressSVG from "./svg/location-address.svg"
import LocationCatchAllSVG from "./svg/location-catch-all.svg"
import PhoneMessageSVG from "./svg/phone-message.svg"
import IntegrationInstructionsSVG from "./svg/integration-instructions.svg"
import GestureSelectSVG from "./svg/gesture-select.svg"
import StylusNoteSVG from "./svg/stylus-note.svg"
import DragPanSVG from "./svg/drag-pan.svg"
import PencilSquareSVG from "./svg/pencil-square.svg"
import ContentCopySVG from "./svg/content-copy.svg"
import TerminalSVG from "./svg/terminal.svg"
import ClearAllSVG from "./svg/clear-all.svg"
import CloudAlertSVG from "./svg/cloud-alert.svg"
import LockSVG from "./svg/lock.svg"
import PlayVideoSVG from "./svg/play-video.svg"
import UploadFolderSVG from "./svg/upload-folder.svg"
import ImportVideoSVG from "./svg/import-video.svg"
import ImportImagesSVG from "./svg/import-images.svg"
import HorizontalKeySVG from "./svg/horizontal-key.svg"
import EmailSVG from "./svg/email.svg"
import AuthCheckCircleSVG from "./svg/auth-check-circle.svg"
import CardsStarSVG from "./svg/cards-star.svg"
import LocalLibrarySVG from "./svg/local-library.svg"
import ArrowCoolDownSVG from "./svg/arrow-cool-down.svg"
import MergeSVG from "./svg/merge.svg"
import ArrowSplitSVG from "./svg/arrow-split.svg"
import UnmergeSVG from "./svg/unmerge.svg"
import LoginSVG from "./svg/login.svg"
import LogoutSVG from "./svg/logout.svg"
import SyncSVG from "./svg/sync.svg"
import SyncDisabledSVG from "./svg/sync-disabled.svg"
import SunSVG from "./svg/sun.svg"
import MoonSVG from "./svg/moon.svg"
import LayoutSVG from "./svg/layout.svg"
import PDFBorderTicksSVG from "./svg/pdf-border-ticks.svg"
import PDFFeaturesSVG from "./svg/pdf-features.svg"
import PDFGridLinesSVG from "./svg/pdf-grid-lines.svg"
import PDFLogosSVG from "./svg/pdf-logos.svg"
import PDFMapPositionSVG from "./svg/pdf-map-position.svg"
import PDFMetadataSVG from "./svg/pdf-meta-data.svg"
import PDFOrientationSVG from "./svg/pdf-orientation.svg"
import PDFPageSizeSVG from "./svg/pdf-page-size.svg"
import PDFRatioSVG from "./svg/pdf-ratio.svg"
import PDFTextSVG from "./svg/pdf-text.svg"
import PDFTitlesSVG from "./svg/pdf-titles.svg"
import RemoveSelectionSVG from "./svg/remove-selection.svg"
import DesignServicesSVG from "./svg/design-services.svg"
import ArrowDropUpSVG from "./svg/arrow-drop-up.svg"
import RefreshSVG from "./svg/refresh.svg"
import ChartSVG from "./svg/chart.svg"
import AddChartSVG from "./svg/add-chart.svg"
import DoubleUpArrowSVG from "./svg/double-up-arrow.svg"
import DoubleDownArrowSVG from "./svg/double-down-arrow.svg"
import ConciergeSVG from "./svg/concierge.svg"
import OrthoSVG from "./svg/ortho.svg"
import OrthoAddOnSVG from "./svg/ortho-add-on.svg"
import AwardStarSVG from "./svg/award-star.svg"
import GraphicEQSVG from "./svg/graphic-eq.svg"
import DistanceSVG from "./svg/distance.svg"
import ExpandContentSVG from "./svg/expand-content.svg"
import FilterListSVG from "./svg/filter-list.svg"
import AccountCircleSVG from "./svg/account-circle.svg"
import CalendarMonthSVG from "./svg/calendar-month.svg"
import PhotoLibrarySVG from "./svg/photo-library.svg"
import FitScreenSVG from "./svg/fit-screen.svg"
import LeftPanelOpenSVG from "./svg/left-panel-open.svg"
import LeftPanelCloseSVG from "./svg/left-panel-close.svg"
import LayerLockedSVG from "./svg/layer-locked.svg"
import LayerUnlockedSVG from "./svg/layer-unlocked.svg"
import CancelSVG from "./svg/cancel.svg"
import DotSVG from "./svg/dot.svg"
import BrokenImageSVG from "./svg/broken-image.svg"
import CloseCircleSVG from "./svg/close-circle.svg"
import AddImageSVG from "./svg/add-image.svg"
import ArchiveSVG from "./svg/archive.svg"
import FrameInspectSVG from "./svg/frame-inspect.svg"
import KeyboardDoubleArrowDownSVG from "./svg/keyboard-double-arrow-down.svg"
import KeyboardDoubleArrowLeftSVG from "./svg/keyboard-double-arrow-left.svg"
import KeyboardDoubleArrowRightSVG from "./svg/keyboard-double-arrow-right.svg"
import KeyboardDoubleArrowUpSVG from "./svg/keyboard-double-arrow-up.svg"
import FirstPageSVG from "./svg/first-page.svg"
import LastPageSVG from "./svg/last-page.svg"
import ControlCameraSVG from "./svg/control-camera.svg"
import NotListedLocationSVG from "./svg/not-listed-location.svg"
import BrightnessAlertSVG from "./svg/brightness-alert.svg"
import BeenHereSVG from "./svg/beenhere.svg"
import DangerousSVG from "./svg/dangerous.svg"
import ReplySVG from "./svg/reply.svg"
import ColorFinderMapDefaultSVG from "./svg/colorfinder-map-default.svg"
import SmMapSVG from "./svg/sm-map.svg"
import LgMapSVG from "./svg/lg-map.svg"
import FullscreenSVG from "./svg/fullscreen.svg"
import FullscreenExitSVG from "./svg/fullscreen-exit.svg"
import VideoLibrarySVG from "./svg/video-library.svg"
import ColorizeSVG from "./svg/colorize.svg"
import SendSVG from "./svg/send.svg"
import ImageSearchSVG from "./svg/image-search.svg"
import ColorFinderSVG from "./svg/colorfinder.svg"
import ChatSVG from "./svg/chat.svg"
import MoreVertSVG from "./svg/more-vert.svg"
import AssistantNavigationSVG from "./svg/assistant-navigation.svg"
import AssistantNavigationFilledSVG from "./svg/assistant-navigation-filled.svg"
import DroneVideoIconSVG from "./svg/drone-video-icon.svg"
import VideoOffSVG from "./svg/video-off.svg"
import ExpandAllSVG from "./svg/expand-all.svg"
import CollapseAllSVG from "./svg/collapse-all.svg"
import AppleSVG from "./svg/apple.svg"
import GoogleSVG from "./svg/google.svg"
import MicrosoftSVG from "./svg/microsoft.svg"
import ActiveGlobalNavBorderSVG from "./svg/active-global-nav-border.svg"
import NotificationSVG from "./svg/notification.svg"
import PasswordSVG from "./svg/password.svg"
import CollaboratorSVG from "./svg/collaborator.svg"
import VolumeUpSVG from "./svg/volume-up.svg" // TODO @connor use proper icon when we get it
import VolumeDownSVG from "./svg/volume-down.svg" // TODO @connor use proper icon when we get it
import VolumeOffSVG from "./svg/volume-off.svg" // TODO @connor use proper icon when we get it
import TVOptionsInputSettingsSVG from "./svg/tv-options-input-settings.svg"
import TuneSVG from "./svg/tune.svg"
import AccountTreeSVG from "./svg/account-tree.svg"
import IdCardSVG from "./svg/id-card.svg"
import AddDiamondSVG from "./svg/add-diamond.svg"
import WorkspaceArrowSVG from "./svg/workspace-arrow.svg"
import AddAPhotoSVG from "./svg/add-a-photo.svg"
import NoProfilePictureSVG from "./svg/no-profile-picture.svg"
import DroneSVG from "./svg/drone.svg"
import ControllerSVG from "./svg/controller.svg"
import RouteSVG from "./svg/route.svg"
import BlurOnSVG from "./svg/blur-on.svg"
import ArrowCoolUpSVG from "./svg/arrow-cool-up.svg"
import ForestSVG from "./svg/forest.svg"
import UrbanSVG from "./svg/urban.svg"
import RapidSVG from "./svg/rapid.svg"
import RadarSVG from "./svg/radar.svg"
import Graph7SVG from "./svg/graph-7.svg"
import ConversionPathSVG from "./svg/conversion-path.svg"
import Drone2SVG from "./svg/drone2.svg"
import PreliminarySVG from "./svg/preliminary.svg"
import DocsSVG from "./svg/docs.svg"
import BuildSVG from "./svg/build.svg"
import PersonBookSVG from "./svg/person-book.svg"
import LinkSVG from "./svg/link.svg"
import Battery0BarSVG from "./svg/battery-0-bar.svg"
import Battery1BarSVG from "./svg/battery-1-bar.svg"
import Battery2BarSVG from "./svg/battery-2-bar.svg"
import Battery3BarSVG from "./svg/battery-3-bar.svg"
import Battery4BarSVG from "./svg/battery-4-bar.svg"
import Battery5BarSVG from "./svg/battery-5-bar.svg"
import Battery6BarSVG from "./svg/battery-6-bar.svg"
import BatteryAlertSVG from "./svg/battery-alert.svg"
import BatteryCharging20SVG from "./svg/battery-charging-20.svg"
import BatteryFullSVG from "./svg/battery-full.svg"
import BatteryUnknownSVG from "./svg/battery-unknown.svg"
import ScheduleSVG from "./svg/schedule.svg"
import ClockSVG from "./svg/clock.svg"
import AndroidWifiBarSVG from "./svg/android-wifi-bar.svg"
import LocationOnSVG from "./svg/location-on.svg"
import AcuteSVG from "./svg/acute.svg"
import SubdirectoryArrowRightSVG from "./svg/subdirectory-arrow-right.svg"
import ModelTrainingSVG from "./svg/model_training.svg"
import ModelTrainingGradientSVG from "./svg/model_training_gradient.svg"
import NoteAddSVG from "./svg/note_add.svg"
import PDFCustomSVG from "./svg/pdf-custom.svg"
import CSVSVG from "./svg/csv.svg"
import TextSelectStartSVG from "./svg/text-select-start.svg"
import CallSVG from "./svg/call.svg"
import FormatH1SVG from "./svg/format-h1.svg"
import SortByAlphaAscSVG from "./svg/sort-by-alpha-asc.svg"
import SortByAlphaDescSVG from "./svg/sort-by-alpha-desc.svg"
import CheckCircleSVG from "./svg/check-circle.svg"
import AlarmOnSVG from "./svg/alarm-on.svg"
import SortSVG from "./svg/sort.svg"
import DragHandleSVG from "./svg/drag-handle.svg"
import LinkOffSVG from "./svg/link-off.svg"
import AddTaskSVG from "./svg/add_task.svg"
import LapsSVG from "./svg/laps.svg"
import BoundingBoxSVG from "./svg/bounding-box.svg"
import CaptivePortalSVG from "./svg/captive-portal.svg"
import DirectionsRunSVG from "./svg/directions-run.svg"
import E911EmergencySVG from "./svg/e911-emergency.svg"
import LocalFireDepartmentSVG from "./svg/local-fire-department.svg"
import FireTruckSVG from "./svg/fire-truck.svg"
import DomainSVG from "./svg/domain.svg"
import AdminPanelSettingsSVG from "./svg/admin-panel-settings.svg"
import LocalPoliceSVG from "./svg/local-police.svg"
import EmergencySVG from "./svg/emergency.svg"
import HealthCrossSVG from "./svg/health-cross.svg"
import ViewAgendaSVG from "./svg/view-agenda.svg"
import AspectRatioSVG from "./svg/aspect-ratio.svg"
import VideoCamSVG from "./svg/videocam.svg"
import GlobeSVG from "./svg/globe.svg"
import ShieldPersonSVG from "./svg/shield-person.svg"
import BrowseGallerySVG from "./svg/browser-gallery.svg"
import ContactPageSVG from "./svg/contact-page.svg"
import FormatListBulletedSVG from "./svg/format-list-bulleted.svg"
import GroupsSVG from "./svg/groups.svg"
import CropSVG from "./svg/crop.svg"
import RectangleSVG from "./svg/rectangle.svg"
import Rotate90DegreesCWSVG from "./svg/rotate-90-degrees-cw.svg"
import Rotate90DegreesCCWSVG from "./svg/rotate-90-degrees-ccw.svg"
import ZoomInSVG from "./svg/zoom-in.svg"
import ZoomOutSVG from "./svg/zoom-out.svg"
import ChatBubbleSVG from "./svg/chat-bubble.svg"
import CommentBubbleSVG from "./svg/comment-bubble.svg"
import AddReactionSVG from "./svg/add-reaction.svg"
import AlternateEmailSVG from "./svg/alternate-email.svg"
import AddPhotoAlternateSVG from "./svg/add-photo-alternate.svg"
import SatelliteSVG from "./svg/satellite.svg"
import SatelliteColorSVG from "./svg/satellite-color.svg"
import FeatureSearchSVG from "./svg/feature-search.svg"
import AlignHorizontalCenterSVG from "./svg/align-horizontal-center.svg"
import AlignHorizontalLeftSVG from "./svg/align-horizontal-left.svg"
import AlignHorizontalRightSVG from "./svg/align-horizontal-right.svg"
import PlannerReviewSVG from "./svg/planner-review.svg"
import NotificationSettingsSVG from "./svg/notification-settings.svg"
import NotificationStatusSVG from "./svg/notification-status.svg"
import NovaPFPSVG from "./svg/nova-pfp.svg"
import WeatherSVG from "./svg/weather.svg"
import WindSVG from "./svg/wind.svg"
import PrecipitationSVG from "./svg/precipitation.svg"
import LightningSVG from "./svg/lightning.svg"
import BarrierBlockSVG from "./svg/barrier-block.svg"
import ConnectingAirportsSVG from "./svg/connecting-airports.svg"
import FixedWingSVG from "./svg/fixed-wing.svg"
import HelicopterSVG from "./svg/helicopter.svg"
import LTASVG from "./svg/lta.svg"
import GliderSVG from "./svg/glider.svg"
import OtherSVG from "./svg/other.svg"
import InboundSVG from "./svg/inbound.svg"
import OutboundSVG from "./svg/outbound.svg"
import HeatSVG from "./svg/heat.svg"
import ElevationSVG from "./svg/elevation.svg"
import CivilizationSVG from "./svg/civilization.svg"
import FireDangerSVG from "./svg/fire-danger.svg"
import GeostationarySVG from "./svg/geostationary.svg"
import WildfiresSVG from "./svg/wildfires.svg"
import AtlasNoBgSVG from "./svg/atlas-no-bg.svg"
import TargetSVG from "./svg/target.svg"
import QuestionSVG from "./svg/question.svg"
import SportsEsportsSVG from "./svg/sports-esports.svg"

type IconRenderable = IconComponent | string

/**
 * Adds a classname to a component
 * @param Component component to extend
 * @returns component with classname applied
 */
function withClassName(Component: IconRenderable, ...classnames: string[]): IconComponent {
    const IconComp = Component as IconComponent
    return (p: React.SVGAttributes<SVGElement>) => {
        const props = {
            ...p,
            className: cn("icon", p.className, ...classnames),
        }
        return <IconComp {...props} />
    }
}

export const Gear = GearSVG
export const CommentBubble = CommentBubbleSVG
export const ChatBubble = ChatBubbleSVG
export const AddReaction = AddReactionSVG
export const AlternateEmail = AlternateEmailSVG
export const AddPhotoAlternate = AddPhotoAlternateSVG
export const DatePicker = withClassName(DatePickerSVG)
export const Download = DownloadSVG
export const DownloadFull = DownloadFullSVG
export const Edit = EditSVG
export const Exclamation = ExclamationSVG
export const ExclamationTriangle = ExclamationTriangleSVG
export const Remove = withClassName(RemoveSVG)
export const Return = withClassName(ReturnSVG)
export const Save = withClassName(SaveSVG)
export const ColorTimeline = ColorTimelineSVG
export const ColorSpace = ColorSpaceSVG
export const Crosshair = CrosshairSVG
export const BoundingBox = BoundingboxSVG
export const DragLight = DragLightSVG
export const DragDark = DragDarkSVG
export const Hotspot = HotspotSVG
export const LiveDrone = LiveDroneSVG // AKA: Sensors
export const HotspotHeatDot = HotspotHeatDotSVG
export const FlightPath = FlightPathSVG
export const Perimeter = PerimeterSVG
export const PerimeterThick = PerimeterThickSVG
export const Polygon = PolygonThumbnailSVG
export const Home = HomeSVG
export const NovaLogo = NovaLogoSVG
export const NovaLogoInverted = NovaLogoInvertedSVG
export const NovaLogoStripped = NovaLogoStrippedSVG
export const NovaLogoV2 = NovaLogoV2SVG
export const NovaLogoTitle = NovaLogoTitleSVG
export const QuestionMark = withClassName(QuestionMarkSVG)
export const Crown = CrownSVG
export const PerimeterDistance = PerimeterDistanceSVG
export const RulerToolIcon = RulerToolIconSVG

type PluginIconProps = { url: string }
export const PluginIcon = ({
    url,
    className,
    ...rest
}: React.ImgHTMLAttributes<Element> & PluginIconProps) => (
    <img
        src={url}
        alt="plugin-icon"
        width={24}
        height={24}
        {...rest}
        className={cn("icon-img", "icon__plugin-image", className)}
    />
)

export const ChevronUp = withClassName(ChevronUpSVG)
export const ChevronDown = withClassName(ChevronDownSVG)
export const ChevronLeft = ChevronLeftSVG
export const ChevronRight = ChevronRightSVG
export const ChevronDoubleUp = withClassName(ChevronDoubleUpSVG)
export const Close = withClassName(CloseSVG)
export const VerticalDots = withClassName(VerticalDotsSVG)
export const Trash = TrashSVG
export const Undo = UndoSVG
export const Redo = RedoSVG
export const Reset = ResetSVG
export const ResetAlt = ResetAltSVG
export const Expand = ExpandSVG
export const Collapse = CollapseSVG
export const NoInternet = withClassName(NoInternetSVG)
export const ArrowSwitch = withClassName(ArrowSwitchSVG)
export const Copy = CopySVG
export const Bell = withClassName(BellSVG)
export const Center = withClassName(Center_SVG)
export const CenterSVG = Center_SVG
// export const ErrorExclamation = withClassName(ErrorExclamationSVG)
export const ErrorExclamation = ErrorExclamationSVG
export const SimpleSmiley = withClassName(SimpleSmileySVG)
export const Hamburger = withClassName(HamburgerSVG)
export const BasicLicense = BasicLicenseSVG
export const StandardLicense = StandardLicenseSVG
export const CreatorLicense = CreatorLicenseSVG
export const ChevronRightDark = ChevronRightDarkSVG
export const StatusError = StatusErrorSVG
export const StatusWarning = StatusWarningSVG
export const StatusMessage = StatusMessageSVG
export const Checkmark = CheckmarkSVG
export const Message = withClassName(MessageSVG)
export const Folder = FolderSVG
export const OpenFolder = withClassName(OpenFolderSVG)
export const Map = MapSVG
export const Kanban = withClassName(KanbanSVG)
export const ReversedKanban = withClassName(ReversedKanbanSVG)
export const XClose = XSVG
export const Weather = WeatherSVG
export const Wind = WindSVG
export const Precipitation = PrecipitationSVG
export const Lightning = LightningSVG
export const ExclamationSymbol = ExclamationSVG
export const QuestionSymbol = QuestionSymbolSVG
export const IconTool = IconToolSVG
export const ActiveIconTool = ActiveIconToolSVG
export const Circle = CircleSVG
export const Square = SquareSVG
export const Triangle = TriangleSVG
export const StarShape = StarShapeSVG
export const Diamond = DiamondSVG
export const Cross = CrossSVG
export const Compass = CompassSVG
export const Asterisk = AsteriskSVG
export const BorderTicks = BorderTickSVG
export const CapitalT = CapitalTSVG
export const CapitalT2 = CapitalT2SVG
export const Document = DocumentSVG
export const Draft = DraftSVG
export const GridLines = GridLineSVG
export const Inset = InsetSVG
export const PngIcon = PngIconSVG
export const QrCode = QrCodeSVG
export const RatioBar = RatioBarSVG
export const ScaleBar = ScaleBarSVG
export const ScaleableClose = CloseSVG
export const ThreeDotsSettings = ThreeDotsSettingsSVG
export const ColoredCompass = ColoredCompassSVG
export const SampleQrCode = SampleQrCodeSVG
export const Cursor = CursorSVG
export const HorizontalKebab = HorizontalKebabSVG
export const PDFIcon = PDFIconSVG
export const SettingsCog = SettingsCogSVG
export const DisabledDownload = withClassName(DisabledDownloadSVG)
export const DarkPDFIcon = DarkPDFIconSVG
export const MapPlugin = MapPluginSVG
export const KeyboardIcon = KeyboardSVG
export const CenterLight = CenterLightSVG
export const Appearence = AppearanceSVG
export const PluginTrash = PluginTrashSVG
export const HiddenPanel = HiddenPanelSVG
export const ShortPanel = ShortPanelSVG
export const ExpandedPanel = ExpandedPanelSVG
export const ColorSwatch = ColorSwatchSVG
export const HeatSwatch = HeatSwatchSVG
export const HexSwatch = HexSwatchSVG
export const HotspotPoint = HotspotPointSVG
export const HotspotHeat = HotspotHeatSVG
export const HotspotHex = HotspotHexSVG
export const HotspotOrthoIcon = HotspotOrthoSVG
export const HotspotPointIcon = HotspotPointSVG
export const HotspotPolygonIcon = HotspotPolygonSVG
export const Gradient = GradientSVG
export const ManualHotspot = ManualHotspotSVG
export const ManualHotspotLight = ManualHotspotLightSVG
export const HotspotNumber = HotspotNumberSVG
export const HotspotSensitivity = HotspotSensitivitySVG
export const HotspotFlightPath = HotspotFlightPathSVG
export const HotspotScanArea = HotspotScanAreaSVG
export const TransparentSwatch = TransparentSwatchSVG
export const Outline = OutlineSVG
export const Fill = FillSVG
export const Invite = InviteSVG
export const Pencil = PencilSVG
export const Plus = PlusSVG
export const Ruler = RulerSVG
export const Length = LengthSVG
export const LineTool = LineToolSVG
export const IconLayer = IconLayerSVG
export const VideoPlugin = VideoPluginSVG
export const LiveVideoPlugin = LiveVideoPluginSVG
export const ColorfinderPlugin = ColorfinderPluginSVG
export const ImageColorfinderPlugin = ImageColorfinderPluginSVG
export const PerimeterPlugin = PerimeterPluginSVG
export const Upload = UploadSVG
export const VisibilityEye = VisibilityEyeSVG
export const VisibilityEyeOff = VisibilityEyeOffSVG
export const PerimeterPluginDark = PerimeterPluginDarkSVG
export const UploadAction = UploadActionSVG
export const UploadImageColorfinder = UploadImageColorfinderSVG
export const UploadVideoColorfinder = UploadVideoColorfinderSVG
export const Automated = AutomatedSVG
export const ManualHotspotAction = ManualHotspotActionSVG
export const Processing = ProcessingSVG
export const LineToolSidePanel = LineToolSidePanelSVG
export const Minus = MinusSVG
export const Group = GroupSVG
export const GroupOpen = GroupOpenSVG
export const CenterWhite = CenterWhiteSVG
export const TextIcon = TextIconSVG
export const FontSize = FontSizeSVG
export const FontBold = FontBoldSVG
export const Orientation = OrientationSVG
export const MapPosition = MapPositionSVG
export const Notation = NotationSVG
export const CoordinateSystem = CoordinateSystemSVG
export const TextSidePanel = TextSidePanelSVG
export const MagnifyingGlass = MagnifyingGlassSVG
export const Filter = FilterSVG
export const KeyboardCommand = KeyboardCommandSVG
export const KeyboardShift = KeyboardShiftSVG
export const KeyboardLeftClick = KeyboardLeftClickSVG
export const KeyboardRightClick = KeyboardRightClickSVG
export const KeyboardBackspace = KeyboardBackspaceSVG
export const Play = PlaySVG
export const PlayCircle = PlayCircleSVG
export const PauseCircle = PauseCircleSVG
export const Pause = PauseSVG
export const NoFilterArrow = NoFilterArrowSVG
export const AscendingArrow = AscendingArrowSVG
export const DescendingArrow = DescendingArrowSVG
export const Share = ShareSVG
export const PanoramaPlugin = PanoramaPluginSVG
export const PanoramaTopLeft = PanoramaTopLeftSVG
export const PanoramaSplit = PanoramaSplitSVG
export const PanoramaFull = PanoramaFullSVG
export const Star = StarSVG
export const StarFill = StarFillSVG
export const UnfoldMore = UnfoldMoreSVG
export const Recent = RecentSVG
// export const Campaign = CampaignSVG
export const Help = HelpSVG
export const Exit = ExitSVG
export const OpenInNew = OpenInNewSVG
export const MoveTo = MoveToSVG
export const CreateFolder = CreateFolderSVG
export const People = PeopleSVG
export const PersonAdd = PersonAddSVG
export const List = ListSVG
export const Grid = GridSVG
export const ArrowUp = ArrowUpSVG
export const ArrowRight = ArrowRightSVG
export const ArrowLeft = ArrowLeftSVG
export const ArrowDropdown = ArrowDropdownSVG
export const ArrowDropdownRight = ArrowDropdownRightSVG
export const Lightbulb = LightbulbSVG
export const Mail = MailSVG
export const MessageBubbleQuick = MessageBubbleQuickSVG
export const Bug = BugSVG
export const Configuration = ConfigurationSVG
export const Pending = PendingSVG
export const ManageAccounts = ManageAccountsSVG
export const Language = LanguageSVG
export const Error = ErrorSVG
export const Warning = WarningSVG
export const Information = InformationSVG
export const Pen4 = Pen4SVG
export const ToolboxMap = ToolboxMapSVG
export const Overlap = OverlapSVG
export const NoAccount = NoAccountSVG
export const Invoice = InvoiceSVG
export const PersonRemove = PersonRemoveSVG
export const PersonEdit = PersonEditSVG
export const ShoppingCart = ShoppingCartSVG
export const Key = KeySVG
export const License = LicenseSVG
export const AddOn = AddOnSVG
export const PersonAdmin = PersonAdminSVG
export const Usage = UsageSVG
export const Upgrade = UpgradeSVG
export const PersonUpgrade = PersonUpgradeSVG
export const CheckoutEssentials = CheckoutEssentialsSVG
export const CheckoutPro = CheckoutProSVG
export const CheckoutColorfinder = CheckoutColorfinderSVG
export const CheckoutHotspots = CheckoutHotspotsSVG
export const CheckoutVideo = CheckoutVideoSVG
export const HotspotAddOn = HotspotAddOnSVG
export const ColorfinderAddOn = ColorFinderAddOnSVG
export const LiveVideoAddOn = LiveVideoAddOnSVG
export const Placeholder = PlaceholderSVG
export const InsertText = InsertTextSVG
export const PinDrop = PinDropSVG
export const Polyline = PolylineSVG
export const Widgets = WidgetsSVG
export const CompassNeedleLight = CompassNeedleLightSVG
export const CompassNeedleDark = CompassNeedleDarkSVG
export const Backup = BackupSVG
export const ZoomTo = ZoomToSVG
export const BucketColor = BucketColorSVG
export const SquareSwatch = SquareSwatchSVG
export const CheckmarkShadow = CheckmarkShadowSVG
export const LineNormal = LineNormalSVG
export const LineDashed = LineDashedSVG
export const LineDotted = LineDottedSVG
export const LineSquared = LineSquaredSVG
export const LineThicknessNormal = LineThicknessNormalSVG
export const LineThicknessThick = LineThicknessThickSVG
export const LineThicknessNone = LineThicknessNoneSVG
export const LineWeightThin = LineWeightThinSVG
export const LineWeightThick = LineWeightThickSVG
export const useAltitude = useAltitudeSVG
export const useLandscape = useLandscapeSVG
export const Stacks = StacksSVG
export const HotsotPlaceable = HotspotPlaceableSVG
export const RestartAlt = RestartAltSVG
export const AddLocation = AddLocationSVG
export const PictureInPicture = PictureInPictureSVG
export const PersonShare = PersonShareSVG
export const EmailList = EmailListSVG
export const ContactEmergency = ContactEmergencySVG
export const Loupe = LoupeSVG
export const GradientWhiteHot = GradientWhiteHotSVG
export const GradientBlackHot = GradientBlackHotSVG
export const GradientTint = GradientTintSVG
export const GradientIronRed = GradientIronRedSVG
export const GradientFulgurite = GradientFulguriteSVG
export const GradientMedical = GradientMedicalSVG
export const GradientDefault = GradientDefaultSVG
export const GradientDefaultSelected = GradientDefaultSelectedSVG
export const LocationCountry = LocationCountrySVG
export const LocationState = LocationStateSVG
export const LocationCity = LocationCitySVG
export const LocationAddress = LocationAddressSVG
export const LocationCatchAll = LocationCatchAllSVG
export const ClearAll = ClearAllSVG
export const CloudAlert = CloudAlertSVG
export const PhoneMessage = PhoneMessageSVG
export const IntegrationInstructions = IntegrationInstructionsSVG
export const GestureSelect = GestureSelectSVG
export const StylusNote = StylusNoteSVG
export const DragPan = DragPanSVG
export const PencilSquare = PencilSquareSVG
export const ContentCopy = ContentCopySVG
export const Terminal = TerminalSVG
export const Lock = LockSVG
export const PlayVideo = PlayVideoSVG
export const ImportVideo = ImportVideoSVG
export const ImportImages = ImportImagesSVG
export const UploadFolder = UploadFolderSVG
export const Email = EmailSVG
export const HorizontalKey = HorizontalKeySVG
export const AuthCheckCircle = AuthCheckCircleSVG
export const CardsStar = CardsStarSVG
export const ArrowCoolDown = ArrowCoolDownSVG
export const LocalLibrary = LocalLibrarySVG
export const Merge = MergeSVG
export const ArrowSplit = ArrowSplitSVG
export const Unmerge = UnmergeSVG
export const Login = LoginSVG
export const Logout = LogoutSVG
export const Sync = SyncSVG
export const SyncDisabled = SyncDisabledSVG
export const Sun = SunSVG
export const Moon = MoonSVG
export const Layout = LayoutSVG
export const PDFBorderTicks = PDFBorderTicksSVG
export const PDFFeatures = PDFFeaturesSVG
export const PDFGridLines = PDFGridLinesSVG
export const PDFLogos = PDFLogosSVG
export const PDFMapPosition = PDFMapPositionSVG
export const PDFMetaData = PDFMetadataSVG
export const PDFOrientation = PDFOrientationSVG
export const PDFPageSize = PDFPageSizeSVG
export const PDFRatio = PDFRatioSVG
export const PDFText = PDFTextSVG
export const PDFTitles = PDFTitlesSVG
export const RemoveSelection = RemoveSelectionSVG
export const DesignServices = DesignServicesSVG
export const ArrowDropUp = ArrowDropUpSVG
export const Refresh = RefreshSVG
export const Chart = ChartSVG
export const AddChart = AddChartSVG
export const DoubleUpArrow = DoubleUpArrowSVG
export const DoubleDownArrow = DoubleDownArrowSVG
export const Concierge = ConciergeSVG
export const Ortho = OrthoSVG
export const OrthoAddOn = OrthoAddOnSVG
export const AwardStar = AwardStarSVG
export const GraphicEQ = GraphicEQSVG
export const Distance = DistanceSVG
export const ExpandContent = ExpandContentSVG
export const FilterList = FilterListSVG
export const AccountCircle = AccountCircleSVG
export const CalendarMonth = CalendarMonthSVG
export const PhotoLibrary = PhotoLibrarySVG
export const FitScreen = FitScreenSVG
export const LeftPanelOpen = LeftPanelOpenSVG
export const LeftPanelClose = LeftPanelCloseSVG
export const LayerLocked = LayerLockedSVG
export const LayerUnlocked = LayerUnlockedSVG
export const Cancel = CancelSVG
export const Dot = DotSVG
export const BrokenImage = BrokenImageSVG
export const CloseCircle = CloseCircleSVG
export const AddImage = AddImageSVG
export const Archive = ArchiveSVG
export const FrameInspect = FrameInspectSVG
export const KeyboardDoubleArrowDown = KeyboardDoubleArrowDownSVG
export const KeyboardDoubleArrowLeft = KeyboardDoubleArrowLeftSVG
export const KeyboardDoubleArrowRight = KeyboardDoubleArrowRightSVG
export const KeyboardDoubleArrowUp = KeyboardDoubleArrowUpSVG
export const FirstPage = FirstPageSVG
export const LastPage = LastPageSVG
export const ControlCamera = ControlCameraSVG
export const Dangerous = DangerousSVG
export const BeenHere = BeenHereSVG
export const BrightnessAlert = BrightnessAlertSVG
export const NotListedLocation = NotListedLocationSVG
export const Reply = ReplySVG
export const ColorFinderMapDefault = ColorFinderMapDefaultSVG
export const SmMap = SmMapSVG
export const LgMap = LgMapSVG
export const Fullscreen = FullscreenSVG
export const FullscreenExit = FullscreenExitSVG
export const VideoLibrary = VideoLibrarySVG
export const Colorize = ColorizeSVG
export const Send = SendSVG
export const ImageSearch = ImageSearchSVG
export const ColorFinder = ColorFinderSVG
export const Chat = ChatSVG
export const MoreVert = MoreVertSVG
export const AssistantNavigation = AssistantNavigationSVG
export const AssistantNavigationFilled = AssistantNavigationFilledSVG
export const DroneVideoIcon = DroneVideoIconSVG
export const VideoOff = VideoOffSVG
export const VolumeUp = VolumeUpSVG
export const VolumeDown = VolumeDownSVG
export const VolumeOff = VolumeOffSVG
export const ExpandAll = ExpandAllSVG
export const CollapseAll = CollapseAllSVG
export const Apple = AppleSVG
export const Google = GoogleSVG
export const Microsoft = MicrosoftSVG
export const ActiveGlobalNavBorder = ActiveGlobalNavBorderSVG
export const Notification = NotificationSVG
export const Password = PasswordSVG
export const Collaborator = CollaboratorSVG
export const TVOptionsInputSettings = TVOptionsInputSettingsSVG
export const Tune = TuneSVG
export const AccountTree = AccountTreeSVG
export const IdCard = IdCardSVG
export const AddDiamond = AddDiamondSVG
export const WorkspaceArrow = WorkspaceArrowSVG
export const AddAPhoto = AddAPhotoSVG
export const NoProfilePicture = NoProfilePictureSVG
export const Drone = DroneSVG
export const Controller = ControllerSVG
export const Route = RouteSVG
export const BlurOn = BlurOnSVG
export const ArrowCoolUp = ArrowCoolUpSVG
export const Forest = ForestSVG
export const Urban = UrbanSVG
export const Rapid = RapidSVG
export const Radar = RadarSVG
export const Graph7 = Graph7SVG
export const ConversionPath = ConversionPathSVG
export const Drone2 = Drone2SVG
export const Preliminary = PreliminarySVG
export const Docs = DocsSVG
export const Build = BuildSVG
export const PersonBook = PersonBookSVG
export const Link = LinkSVG
export const Battery0Bar = Battery0BarSVG
export const Battery1Bar = Battery1BarSVG
export const Battery2Bar = Battery2BarSVG
export const Battery3Bar = Battery3BarSVG
export const Battery4Bar = Battery4BarSVG
export const Battery5Bar = Battery5BarSVG
export const Battery6Bar = Battery6BarSVG
export const BatteryAlert = BatteryAlertSVG
export const BatteryCharging20 = BatteryCharging20SVG
export const BatteryFull = BatteryFullSVG
export const BatteryUnknown = BatteryUnknownSVG
export const Schedule = ScheduleSVG
export const Clock = ClockSVG
export const AndroidWifiBar = AndroidWifiBarSVG
export const LocationOn = LocationOnSVG
export const Acute = AcuteSVG
export const SubdirectoryArrowRight = SubdirectoryArrowRightSVG
export const ModelTraining = ModelTrainingSVG
export const ModelTrainingGradient = ModelTrainingGradientSVG
export const NoteAdd = NoteAddSVG
export const PDFCustom = PDFCustomSVG
export const CSV = CSVSVG
export const TextSelectStart = TextSelectStartSVG
export const Call = CallSVG
export const FormatH1 = FormatH1SVG
export const SortByAlphaAsc = SortByAlphaAscSVG
export const SortByAlphaDesc = SortByAlphaDescSVG
export const CheckCircle = CheckCircleSVG
export const AlarmOn = AlarmOnSVG
export const Sort = SortSVG
export const DragHandle = DragHandleSVG
export const LinkOff = LinkOffSVG
export const AddTask = AddTaskSVG
export const Laps = LapsSVG
export const BoundingBox2 = BoundingBoxSVG
export const CaptivePortal = CaptivePortalSVG
export const DirectionsRun = DirectionsRunSVG
export const E911Emergency = E911EmergencySVG
export const LocalFireDepartment = LocalFireDepartmentSVG
export const FireTruck = FireTruckSVG
export const Domain = DomainSVG
export const AdminPanelSettings = AdminPanelSettingsSVG
export const LocalPolice = LocalPoliceSVG
export const Emergency = EmergencySVG
export const HealthCross = HealthCrossSVG
export const ViewAgenda = ViewAgendaSVG
export const AspectRatio = AspectRatioSVG
export const VideoCam = VideoCamSVG
export const Globe = GlobeSVG
export const ShieldPerson = ShieldPersonSVG
export const BrowseGallery = BrowseGallerySVG
export const ContactPage = ContactPageSVG
export const FormatListBulleted = FormatListBulletedSVG
export const Groups = GroupsSVG
export const Crop = CropSVG
export const Rectangle = RectangleSVG
export const Rotate90DegreesCW = Rotate90DegreesCWSVG
export const Rotate90DegreesCCW = Rotate90DegreesCCWSVG
export const ZoomIn = ZoomInSVG
export const ZoomOut = ZoomOutSVG
export const Satellite = SatelliteSVG
export const SatelliteColor = SatelliteColorSVG
export const FeatureSearch = FeatureSearchSVG
export const AlignHorizontalCenter = AlignHorizontalCenterSVG
export const AlignHorizontalLeft = AlignHorizontalLeftSVG
export const AlignHorizontalRight = AlignHorizontalRightSVG
export const PlannerReview = PlannerReviewSVG
export const NotificationSettings = NotificationSettingsSVG
export const NotificationStatus = NotificationStatusSVG
export const NovaPFP = NovaPFPSVG
export const BarrierBlock = BarrierBlockSVG
export const ConnectingAirports = ConnectingAirportsSVG
export const FixedWing = FixedWingSVG
export const Helicopter = HelicopterSVG
export const LTA = LTASVG
export const Glider = GliderSVG
export const Other = OtherSVG
export const Inbound = InboundSVG
export const Outbound = OutboundSVG
export const Heat = HeatSVG
export const Elevation = ElevationSVG
export const Civilization = CivilizationSVG
export const FireDanger = FireDangerSVG
export const Geostationary = GeostationarySVG
export const Wildfires = WildfiresSVG
export const AtlasNoBg = AtlasNoBgSVG
export const Target = TargetSVG
export const Question = QuestionSVG
export const SportsEsports = SportsEsportsSVG

export { default as VRPano } from "./svg/vrpano.svg"

export const IconBox = ({
    children,
    className,
}: { className?: string } & React.PropsWithChildren) => (
    <div className={cn("icon__box", className)}>{children}</div>
)

const encodeColorToNumber = (color: string) => {
    if (color.at(0) !== "#") throw "Invalid hex color"
    let number = 0x00
    for (let i = 1; i < color.length; i += 2) {
        const idx = (i - 1) / 2
        if (idx > 3 || idx < 0) throw "Invalid hex length"
        const n = parseInt(color.substring(i, i + 2), 16)
        number |= n << (8 * (3 - idx))
    }

    // If number has no alpha, set to FF.
    if ((number & 0xff) === 0) number |= 0xff

    return number >>> 0
}

function rgb2hcb(r: number, g: number, b: number) {
    const PI = Math.PI
    const TAU = PI * 2

    const brightness = (r + g + b) / 3.0
    const chroma = Math.sqrt((r - brightness) ** 2 + (g - brightness) ** 2 + (b - brightness) ** 2)
    const hue = (Math.atan2(r - b, g - b) - PI / 4.0 + TAU) % TAU
    return [hue, chroma, brightness]
}

const colorIsDark = (color: number) => {
    color = color >>> 0
    const r = (color >> 24) & 0xff
    const g = (color >> 16) & 0xff
    const b = (color >> 8) & 0xff

    const [, , brightness] = rgb2hcb(r, g, b)

    return brightness < 0x20
}

/**
 * UI Next Steps
 * 24x24 standard icon.
 */
export const Icon = ({
    Icon,
    iconClassName,
    accentColor,
    ...rest
}: {
    Icon: IconRenderable
    iconClassName?: string
    /** Hex code including # */
    accentColor?: string
} & React.HTMLAttributes<HTMLElement>) => {
    const IconComp = Icon as IconComponent
    const shouldStrokeAccentColor = accentColor
        ? colorIsDark(encodeColorToNumber(accentColor))
        : false

    return (
        <div
            {...rest}
            className={cn(rest.className, "w-6 h-6 flex items-center justify-center relative")}
            style={
                {
                    ...rest.style,
                    "--accent": accentColor || "currentColor",
                    "--accent-stroke": shouldStrokeAccentColor ? "#ffffff7F" : "transparent",
                    "--accent-stroke-width": shouldStrokeAccentColor ? 0.5 : 0,
                } as React.CSSProperties
            }
        >
            <IconComp className={cn(iconClassName, "absolute")} />
        </div>
    )
}

/**
 * UI Next Steps
 * Transforms a 24x24 icon into a 32x32.
 */
export const LargeIcon = ({
    Icon,
    iconClassName,
    accentColor,
    ...rest
}: {
    Icon: IconRenderable
    iconClassName?: string
    /** Hex code including # */
    accentColor?: string
} & React.HTMLAttributes<HTMLElement>) => {
    const IconComp = Icon as IconComponent
    const shouldStrokeAccentColor = accentColor
        ? colorIsDark(encodeColorToNumber(accentColor))
        : false

    return (
        <div
            {...rest}
            className={cn(rest.className, "w-8 h-8 flex items-center justify-center")}
            style={
                {
                    ...rest.style,
                    "--accent": accentColor || "currentColor",
                    "--accent-stroke": shouldStrokeAccentColor ? "#ffffff7F" : "transparent",
                    "--accent-stroke-width": shouldStrokeAccentColor ? 0.5 : 0,
                } as React.CSSProperties
            }
        >
            <IconComp className={cn(iconClassName, "absolute scale-icon-lg")} />
        </div>
    )
}

/**
 * UI Next Steps
 * Transforms a 24x24 icon into a 40x40.
 */
export const HalfExtraLargeIcon = ({
    Icon,
    iconClassName,
    accentColor,
    ...rest
}: {
    Icon: IconRenderable
    iconClassName?: string
    /** Hex code including # */
    accentColor?: string
} & React.HTMLAttributes<HTMLElement>) => {
    const IconComp = Icon as IconComponent
    const shouldStrokeAccentColor = accentColor
        ? colorIsDark(encodeColorToNumber(accentColor))
        : false

    return (
        <div
            {...rest}
            className={cn(rest.className, "w-10 h-10 flex items-center justify-center relative")}
            style={
                {
                    ...rest.style,
                    "--accent": accentColor || "currentColor",
                    "--accent-stroke": shouldStrokeAccentColor ? "#ffffff7F" : "transparent",
                    "--accent-stroke-width": shouldStrokeAccentColor ? 0.5 : 0,
                } as React.CSSProperties
            }
        >
            <IconComp className={cn(iconClassName, "absolute scale-icon-hxl")} />
        </div>
    )
}

/**
 * UI Next Steps
 * Transforms a 24x24 icon into a 48x48.
 */
export const ExtraLargeIcon = ({
    Icon,
    iconClassName,
    accentColor,
    ...rest
}: {
    Icon: IconRenderable
    iconClassName?: string
    /** Hex code including # */
    accentColor?: string
} & React.HTMLAttributes<HTMLElement>) => {
    const IconComp = Icon as IconComponent
    const shouldStrokeAccentColor = accentColor
        ? colorIsDark(encodeColorToNumber(accentColor))
        : false

    return (
        <div
            {...rest}
            className={cn(rest.className, "w-12 h-12 flex items-center justify-center relative")}
            style={
                {
                    ...rest.style,
                    "--accent": accentColor || "currentColor",
                    "--accent-stroke": shouldStrokeAccentColor ? "#ffffff7F" : "transparent",
                    "--accent-stroke-width": shouldStrokeAccentColor ? 0.5 : 0,
                } as React.CSSProperties
            }
        >
            <IconComp className={cn(iconClassName, "absolute scale-icon-xl")} />
        </div>
    )
}

/**
 * UI Next Steps
 * Transforms a 24x24 icon into a 20x20.
 */
export const SmallIcon = ({
    Icon,
    iconClassName,
    accentColor,
    ...rest
}: {
    Icon: IconRenderable
    iconClassName?: string
    /** Hex code including # */
    accentColor?: string
} & React.HTMLAttributes<HTMLElement>) => {
    const IconComp = Icon as IconComponent
    const shouldStrokeAccentColor = accentColor
        ? colorIsDark(encodeColorToNumber(accentColor))
        : false

    return (
        <div
            {...rest}
            className={cn(rest.className, "w-5 h-5 flex items-center justify-center relative")}
            style={
                {
                    ...rest.style,
                    "--accent": accentColor || "currentColor",
                    "--accent-stroke": shouldStrokeAccentColor ? "#ffffff7F" : "transparent",
                    "--accent-stroke-width": shouldStrokeAccentColor ? 0.5 : 0,
                } as React.CSSProperties
            }
        >
            <IconComp className={cn(iconClassName, "absolute scale-icon-sm")} />
        </div>
    )
}

/**
 * UI Next Steps
 * Transforms a 24x24 icon into a 16x16.
 */
export const ExtraSmallIcon = ({
    Icon,
    iconClassName,
    accentColor,
    ...rest
}: {
    Icon: IconRenderable
    iconClassName?: string
    /** Hex code including # */
    accentColor?: string
} & React.HTMLAttributes<HTMLElement>) => {
    const IconComp = Icon as IconComponent
    const shouldStrokeAccentColor = accentColor
        ? colorIsDark(encodeColorToNumber(accentColor))
        : false

    return (
        <div
            {...rest}
            className={cn(rest.className, "w-4 h-4 flex items-center justify-center relative")}
            style={
                {
                    ...rest.style,
                    "--accent": accentColor || "currentColor",
                    "--accent-stroke": shouldStrokeAccentColor ? "#ffffff7F" : "transparent",
                    "--accent-stroke-width": shouldStrokeAccentColor ? 0.5 : 0,
                } as React.CSSProperties
            }
        >
            <IconComp className={cn(iconClassName, "absolute scale-icon-xs")} />
        </div>
    )
}

const BASE_ICON_SIZE = 24

export const CustomIcon = ({
    Icon,
    size,
    iconClassName,
    accentColor,
    ...rest
}: {
    Icon: IconComponent
    size: { width: number; height: number }
    iconClassName?: string
    accentColor?: string
} & React.HTMLAttributes<HTMLElement>) => {
    const shouldStrokeAccentColor = accentColor
        ? colorIsDark(encodeColorToNumber(accentColor))
        : false

    return (
        <div
            {...rest}
            className={cn(rest.className, "flex items-center justify-center relative")}
            style={
                {
                    ...rest.style,
                    width: size.width,
                    height: size.height,
                    "--accent": accentColor || "currentColor",
                    "--accent-stroke": shouldStrokeAccentColor ? "#ffffff7F" : "transparent",
                    "--accent-stroke-width": shouldStrokeAccentColor ? 0.5 : 0,
                } as React.CSSProperties
            }
        >
            <Icon
                className={cn(iconClassName, "absolute")}
                style={{
                    transform: `scale(${size.width / BASE_ICON_SIZE}, ${size.height / BASE_ICON_SIZE})`,
                }}
            />
        </div>
    )
}

export const ArrowDropDownIcon = ({
    dropdownOpen,
    setDropdownOpen,
    disabled,
    ...rest
}: {
    dropdownOpen: boolean
    setDropdownOpen: (value: boolean) => void
    disabled?: boolean
} & React.HTMLAttributes<HTMLElement>) => {
    return (
        <Icon
            {...rest}
            Icon={ArrowDropdown}
            className={cn("transition duration-150 ease-in-out text-gray-300 cursor-pointer", {
                "rotate-180": dropdownOpen,
                "cursor-not-allowed": disabled,
            })}
            data-testid="organization-selector-close"
            onClick={() => {
                if (!disabled) setDropdownOpen(!dropdownOpen)
            }}
        />
    )
}

export type IconComponent = React.FunctionComponent<React.SVGAttributes<SVGElement>>
